import React from 'react';
import { Container, Box, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const PageTitle = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '2.5rem',
  color: '#1a1a1a',
  marginBottom: '2rem',
  textAlign: 'center',
});

const Message = styled(Typography)({
  fontSize: '1.2rem',
  color: '#666',
  textAlign: 'center',
  marginBottom: '2rem',
});

const IconWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '2rem',
  '& svg': {
    fontSize: '4rem',
    color: '#4caf50',
  },
});

const StyledPaper = styled(Paper)({
  padding: '3rem',
  marginTop: '2rem',
  backgroundColor: '#fafafa',
  border: '1px solid #eee',
  textAlign: 'center',
});

const InfoBox = styled(Box)({
  backgroundColor: '#fff',
  padding: '1.5rem',
  marginTop: '2rem',
  borderRadius: '4px',
  '& > *:not(:last-child)': {
    marginBottom: '1rem',
  },
});

const AffiliatePending = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 8 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <StyledPaper elevation={0}>
            <IconWrapper>
              <CheckCircleOutlineIcon />
            </IconWrapper>

            <PageTitle>Application Received!</PageTitle>
            
            <Message>
              Thank you for applying to our affiliate program. We're excited about the possibility
              of partnering with you!
            </Message>

            <InfoBox>
              <Typography variant="h6" gutterBottom>
                What Happens Next?
              </Typography>
              
              <Typography color="textSecondary" paragraph>
                Our team will carefully review your application within 2-3 business days.
                We'll evaluate your content style, audience engagement, and alignment with
                our brand values.
              </Typography>

              <Typography color="textSecondary" paragraph>
                You'll receive an email notification once we've made a decision. If approved,
                the email will include:
              </Typography>

              <Box sx={{ textAlign: 'left', pl: 2 }}>
                <Typography color="textSecondary" component="ul">
                  <li>Your unique affiliate dashboard login credentials</li>
                  <li>Access to our affiliate resources and guidelines</li>
                  <li>Instructions for setting up your profile and favorite items</li>
                  <li>Information about commission rates and payment schedules</li>
                </Typography>
              </Box>
            </InfoBox>

            <InfoBox>
              <Typography variant="h6" gutterBottom>
                Questions?
              </Typography>
              
              <Typography color="textSecondary">
                If you have any questions about your application or our affiliate program,
                please contact our affiliate support team at{' '}
                <a href="mailto:affiliates@customconnectjewelry.com" style={{ color: '#c4a661' }}>
                  affiliates@customconnectjewelry.com
                </a>
              </Typography>
            </InfoBox>
          </StyledPaper>
        </motion.div>
      </Box>
    </Container>
  );
};

export default AffiliatePending;
